<template>
    <div class="container">
        <ClcmsMenu @productsSelect="productsSelect"/>
        <div>
            <div class="title" data-aos="fade-up">
                细胞资源库建设整体规划服务
            </div>
            <div class="introduction" >
                <div class="introductionTitle">
                    <h1 data-aos="fade-up"></h1>
<!--                    <div data-aos="fade-up"></div>-->
                    <div data-aos="fade-up">上海唐颐信息技术有限公司提供细胞资源库建设整体规划咨询服务，涵盖细胞资源库建设咨询、规划方案设计等配套技术服务。方案围绕细胞资源库规范化运营要求，结合项目实际条件输出适配的建设方案，为打造专业化、标准化细胞资源库提供全面技术支撑。
                    </div>
                </div>
                <div data-aos="zoom-in" style="padding:0 20px">
                    <img :src="require('@/assets/img/products/cellVenue/introductionBg.png')" alt="" >
                </div>
            </div>
            <table class="table">
                <tr data-aos="fade-up">
                    <td>序号</td>
                    <td>名称</td>
                    <td>规划内容</td>
                </tr>
                <tr v-for="item,index in table" data-aos="fade-up">
                    <td>{{index+1}}</td>
                    <td>{{item.name}}</td>
                    <td v-html="item.content"></td>
                </tr>
            </table>
            <div class="lims">
                <div class="limsTitle" data-aos="fade-up">实验室参考</div>
                <div class="pic"><img :src="require('@/assets/img/products/cellVenue/lims.png')" alt="" data-aos="zoom-in"></div>
            </div>
        </div>
    </div>
</template>

<script>
import ClcmsMenu from "../../components/ClcmsMenu";
export default {
    name:'cellVenue',
    components: {ClcmsMenu},
    data(){
      return {
            table:[
                {
                    name:'实验室规划、布局、装修',
                    content:'吊顶装修、隔墙装修、地面装修、圆弧结构、门窗制作安装、<br>不锈钢传递窗、手消毒系统'
                },
                {
                    name:'实验室供电系统',
                    content:'照明电器、紫外线灭菌灯、开关插座、动力配电'
                },
                {
                    name:'实验室自动化控制系统',
                    content:'风机、空调、压力、通风橱、温湿度控制系统等'
                },
                {
                    name:'实验室弱电规划',
                    content:'视频监控、弱电综合网络系统'
                },
                {
                    name:'实验室净化。空调。排风设计及施工',
                    content:'净化级别、送/回/排风系统、压差控制、净化空调机组、空调冷热源'
                },
                {
                    name:'实验室配套',
                    content:'水盆/水槽/水龙头/洗眼器/紧急喷淋系统、滴水架、试剂架、<br>中央实验台、实验边台、高温台、天平台、不锈钢操作台、<br>药品柜/器皿柜/钢瓶柜/样品柜、通风厨/通风罩/原子吸收罩'
                },
            ]
      }
    },
    methods:{
        productsSelect(src){
	        this.$emit('productsSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
        padding-top: 20px;
    }
    .title{
        width: 417px;
        height: 60px;
        font-family: SourceHanSansCN-Normal;
        font-size: 30px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 24px;
        letter-spacing: 2px;
        color: #ed1c24;
        margin: 100px 27% 65px;
        background: url("../../assets/img/products/cellVenue/introductionTitle.png") 100% 100%;;
    }
    .introduction{
        width: 941px;
        margin: 0px 65px;
        display: flex;
        justify-content: space-between;
        .introductionTitle{
            margin-right: 70px;
            h1{
                font-size: 19px;
            }
            &>div:nth-child(2){
                width: 579px;
                font-size: 15px;
                letter-spacing: 1px;
                line-height: 25px;
                color: #333333;
                padding-top: 56px;
            }

        }
    }
    .table{
        margin-top: 80px;
        margin-left: 7%;
        tr{
            height: 75px;
            td{
                /*display: flex;*/
                /*justify-content: center;*/
                /*align-items: center;*/
                /*flex-wrap: wrap;*/
                background: #f3f3f3;
                text-align: center;
                box-sizing: border-box;
                letter-spacing: 1px;
                font-size: 15px;
            }
            td:nth-child(1){
                width: 105px;
            }
            td:nth-child(2){
                width: 366px;
                text-align: left;
                padding-left: 36px;
            }
            td:nth-child(3){
                width: 503px;
                text-align: left;
                padding-left: 12px;
            }
        }
        tr:nth-child(1){
            td{
                text-align: center;
                letter-spacing: 2px;
                font-size: 20px;
            }
        }
    }
    .lims{
        margin: 85px 0;
        .limsTitle{
            font-size: 30px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 24px;
            letter-spacing: 2px;
            color: #ed1c24;
            text-align: center;
            width: 323px;
            height: 59px;
            background: url("../../assets/img/products/cellVenue/limsTitle.png");
            margin-left: 28.5%;
        }
        .pic{
            margin-top: 52px;
            padding-left: 5.5%;
        }
    }
</style>
